// Importación de React y la imagen de fondo.
import React from 'react';
import imagenFondo from '../img/uno.jpg'; // Imagen que se usará como fondo del banner.

/**
 * Componente BannerServicios.
 * Muestra un banner a pantalla completa con una imagen de fondo fija,
 * un título principal y un subtítulo.
 */
const BannerServicios = () => {
  return (
    // Contenedor principal que ocupa toda la pantalla (w-screen, h-screen).
    // Utiliza flexbox para centrar el contenido vertical y horizontalmente.
    <div
      className="text-white w-screen h-screen bg-cover bg-center flex flex-col justify-center items-center"
      style={{ 
        backgroundImage: `url(${imagenFondo})`, // Aplica la imagen de fondo dinámicamente.
        backgroundAttachment: 'fixed' // Fija la imagen de fondo para crear un efecto de parallax al hacer scroll.
      }}
    >
      {/* Título principal del banner. */}
      <h2 className='text-center mb-4 md:text-5xl sm:text-4xl text-3xl font-bold'>NUESTROS SERVICIOS</h2>
      
      {/* Subtítulo o descripción. */}
      <p className="mb-4 md:text-4xl sm:text-3xl text-2xl">Consultoría Tecnológica</p>
      
      {/* El siguiente botón está comentado, por lo que no se renderizará en la página. */}
      {/* 
      <button className="bg-blue-500 text-white h-20 w-52 py-1 px-4 rounded-lg border-transparent hover:bg-blue-600 transition-colors duration-300">
        Solicita tu evaluación ¡GRATIS!
      </button> 
      */}
    </div>
  );
};

// Exporta el componente para ser utilizado en otras partes de la aplicación, como en la página de Servicios.
export default BannerServicios;
